
import {Ocular} from '../lib/Ocular';

const ocular = new Ocular();
ocular.init();

if (ocular.list.length > 0) {
  $.get('/resources/dist/templates/recently-viewed.hbs').done((data) => {
    const source = $(data).html();
    const template = Handlebars.compile(source);
    const elHtml = template(ocular);
    $(elHtml).appendTo('.recently-viewed');
  });
}

function contextualNavToggle() {
  const navSecondary = $('.nav-secondary');

  $(this).find('.sub-menu-toggle').toggleClass('is-active');
  const el = $(this).find('.sub-menu');
  el.toggleClass('is-open');
  if (el.hasClass('is-open')) {
    navSecondary.attr('aria-expanded', 'true');
  } else {
    navSecondary.attr('aria-expanded', 'false');
  }
}

$('.recently-viewed').click(contextualNavToggle);
$('.translations').click(contextualNavToggle);
